/* eslint-disable no-restricted-syntax */
import "isomorphic-fetch";
import { StorageHandler } from "C4";
import { storageKeys } from "settings";

const { Raven } = window;

let APIHandler;
export default APIHandler = {
  makeRequest: (request, settings, customErrorHandler) =>
    fetch(request, settings)
      .then((response) => {
        if (response.ok) {
          return response
            .json()
            .then((json) => json)
            .catch(() => false);
        }
        return { ok: false, response };
      })
      .catch((err) => {
        if (customErrorHandler) {
          console.log(err);
          // customErrorHandler(err);
        } else {
          // Raven.captureException('API call failed', {
          //   extra: { requestURL: request, requestSettings: settings, err },
          // });
        }
        return false;
      }),

  ok: (response) => {
    if (!response) {
      return false;
    }
    if (Object.keys(response).length > 0) {
      return true;
    }
    return false;
  },

  timeout(ms, promise) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error("timeout"));
      }, ms);
      promise.then(resolve, reject);
    });
  },

  lastActive: (appId, email) => {
    const request = `https://crm.travpromobile.com/api/event?app_id=${appId}&email=${email}&action=open&category=last-active&name=app&value=session`;

    const requestSettings = {
      method: "POST",
      timeout: 5000,
    };

    const onError = (err) => {
      console.log("error: ", err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => res
    );
  },

  getUserOld: (appId, email) => {
    const request = `https://accounts.travpromobile.com/api/v2/get_user/?email=${encodeURI(
      email
    )}&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getUser: async (appId, accessToken) => {
    const request = `https://login.travpromobile.com/api/getUser/?app_id=${appId}`;

    const requestSettings = {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      method: "GET",
      timeout: 5000,
    };

    const onError = (err) => {
      console.log("Error: ", err);
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      return err;
    };

    const res = await APIHandler.makeRequest(
      request,
      requestSettings,
      requestSettings,
      onError
    );

    if (res.response && res.response.status !== 200) {
      console.log(res.response);
      return res;
    }
    return res;
  },

  checkPasswordUser: (email, password) => {
    const request = "https://crm.travpromobile.com/api/authenticateMalibu";
    const data = {
      email,
      password,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: "POST",
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then((res) => res);
  },

  setUser: (appId, params) => {
    // Format Date to dd-mm-yyyy, by adding a leading 0 and
    // slice last 2 characters to get Month and Day in two decimals.
    const date = new Date();
    const Month = `0${date.getMonth() + 1}`;
    const Day = `0${date.getDay()}`;
    const Year = date.getFullYear();
    const dateFormat = `${Year}-${Month.slice(-2)}-${Day.slice(-2)}`;

    let request = "https://accounts.travpromobile.com/api/v2/user/?";
    request += `sales_companion_registered=${dateFormat}&`;
    request += `app_id=${appId}&`;
    request += "type_of_user=pro";

    Object.keys(params).forEach((key) => {
      request += `&${key.replace(new RegExp("reg_", "g"), "")}=${encodeURI(
        params[key]
      )}`;
    });

    return APIHandler.makeRequest(request);
  },

  updateUser: (appId, email, params) => {
    const parameters = params
      .map((p, i) => `${i > 0 ? "&" : ""}${p.param}=${p.val}`)
      .join("");
    const request = `https://accounts.travpromobile.com/api/v2/user/?email=${email}&${parameters}&app_id=${appId}`;
    return APIHandler.makeRequest(request, null, (err) => {
      Raven.captureException("Updating user failed", {
        extra: { requestURL: request, requestSettings: null, err },
      });
    });
  },

  updateRegisterUser: (appId, email, params) => {
    let request = `https://accounts.travpromobile.com/api/v2/user/?email=${email}&app_id=${appId}`;
    for (let i = 0; i < Object.keys(params).length; i += 1) {
      const objectName = Object.keys(params)[i];
      request += `&${objectName}=${encodeURI(params[objectName])}`;
    }
    return APIHandler.makeRequest(request);
  },

  buildSearchIndex: (appId) => {
    let request = `https://stack.travpromobile.com/buildindex.php?app_id=${appId}`;
    if (appId > 500) {
      request = `https://stack.travpromobile.com/buildindex_v2.php?app_id=${appId}`;
    }
    return APIHandler.makeRequest(request);
  },

  updateSearchIndex: (appId) => {
    const request = `https://search.travpromobile.com/updateindex_v2.php?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getSearchResults: (appId, query) => {
    const request = `https://stack.travpromobile.com/query_v2.php?app_id=${appId}&q=${encodeURIComponent(
      query
    )}`;
    return APIHandler.makeRequest(request);
  },

  setChapterCompleted: (appId, email, chapterId, chapterNumber) => {
    const request = "https://crm.travpromobile.com/api/chapter";
    const data = {
      app_id: appId,
      email,
      chapter_id: chapterId,
      chapter_number: chapterNumber,
    };

    const requestSettings = {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    };

    const onError = (err) => {
      console.log(err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => res
    );
  },

  getBooths: (ids) => {
    let request =
      "https://travproconnect.com/api/v1/companies-filtered/?countrySort=true";
    ids.forEach((id) => {
      request += `&ids[]=${id}`;
    });
    return APIHandler.makeRequest(request);
  },

  getUserProgress: (appId, email) => {
    let request = `https://progress.travpromobile.com/progress_user_v2/?email=${encodeURI(
      email
    )}`;
    if (["number", "string"].includes(typeof appId)) {
      request += `&app_id=${appId}`;
    }
    if (typeof appId === "object") {
      appId.forEach((id) => {
        request += `&app_id[]=${id}`;
      });
    }
    return APIHandler.makeRequest(request);
  },

  registerUserProgress: (email) => {
    const request = "https://progress.travpromobile.com/users/";
    const requestSettings = {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      timeout: 5000,
      body: JSON.stringify({ user: { email } }),
    };

    const onError = (err) => {
      Raven.captureException("Registering user progress failed", {
        extra: { requestURL: request, requestSettings, err },
      });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => {
        if (res.status !== 422) {
          return res;
        }
        return false;
      }
    );
  },

  loginUser: async (username, password) => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { clientId, clientSecret } = appInfo;
    const request = "https://login.travpromobile.com/oauth/token";
    const data = {
      grant_type: "password",
      client_id: clientId,
      client_secret: clientSecret,
      username,
      password,
    };
    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      method: "POST",
      timeout: 5000,
      body,
    };

    const onError = (err) => {
      console.log("Error: ", err);
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      return err;
    };

    const res = await APIHandler.makeRequest(request, requestSettings, onError);

    if (res.response && res.response.status !== 200) {
      return onError(await res.response.clone().json());
    }
    return res;

    // return APIHandler.makeRequest(request, requestSettings, onError)
    //   .then(({ response }) => {
    //     const { status } = response;
    //     if (status !== 200) {
    //       return respone
    //         .then((stream) => {
    //           const res = new Response(stream);
    //           console.log({ res });
    //           return res;
    //         });
    //     }
    //     return response;
    //   });
  },

  registerSSOUser: async (
    name,
    email,
    company,
    password,
    passwordConfirmation
  ) => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { clientId, clientSecret } = appInfo;
    const request = "https://login.travpromobile.com/api/register";
    const data = {
      client_id: clientId,
      client_secret: clientSecret,
      name,
      email,
      company,
      password,
      password_confirmation: passwordConfirmation,
    };

    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      method: "POST",
      timeout: 5000,
      body,
    };

    const onError = (err) => {
      console.log("error: ", err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => res
    );
  },

  forgotPassword: async (email) => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { clientId } = appInfo;
    const request = "https://login.travpromobile.com/api/forgot_password";
    const data = {
      email,
      client_id: clientId,
    };

    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      method: "POST",
      timeout: 5000,
      body,
    };

    const onError = (err) => {
      console.log("error: ", err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => res
    );
  },

  resendVerificationLink(request) {
    const requestSettings = {
      method: "GET",
      timeout: 5000,
    };

    const onError = (err) => {
      console.log("errorL ", err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => res
    );
  },

  getTravUser: (token) => {
    const request = "https://progress.travpromobile.com/users/";
    const requestSettings = {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      timeout: 5000,
      body: JSON.stringify({ user: { email } }),
    };

    const onError = (err) => {
      Raven.captureException("Registering user progress failed", {
        extra: { requestURL: request, requestSettings, err },
      });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => {
        if (res.status !== 422) {
          return res;
        }
        return false;
      }
    );
  },

  getFavoriteContent: (favorites) => {
    const request = "https://cms.travpromobile.com/api/app/favorites/?";
    let params = "";

    favorites.forEach((item) => {
      if (item.type === "p") {
        params += `page[]=${item.unid}&`;
      } else {
        params += `page[]=${item.type}${item.unid}&`;
      }
    });

    return APIHandler.makeRequest(`${request}${params}`);
  },

  getFavorite: (appId, email) => {
    const request = `https://progress.travpromobile.com/favorites_by_app/${appId}/?email=${email}`;
    return APIHandler.makeRequest(request);
  },

  addFavorite: (params) => {
    const request = "https://progress.travpromobile.com/favorites/";
    return APIHandler.makeRequest(request, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      timeout: 5000,
      body: JSON.stringify(params),
    });
  },

  removeFavorite: (params) => {
    const request = "https://progress.travpromobile.com/favorites";

    return APIHandler.makeRequest(request, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "DELETE",
      timeout: 5000,
      body: JSON.stringify(params),
    });
  },

  setUserProgress: (params) => {
    const request = "https://progress.travpromobile.com/progress";

    const requestObject = {
      chapter_id: params.chapterId,
      lastpage: params.lastPage,
      progress: params.progress,
      email: params.email,
    };

    const valid = Object.values(requestObject).every((param) => param);
    const NaNCheck = +requestObject.lastpage && +requestObject.progress;
    const positive =
      +requestObject.lastpage >= 0 && +requestObject.progress >= 0;

    if (valid && NaNCheck && positive) {
      return APIHandler.makeRequest(request, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        timeout: 5000,
        body: JSON.stringify(requestObject),
      });
    }
    return new Promise((resolve) =>
      resolve(new Error("One of the supplied values was invalid."))
    );
  },

  getLocation: () => {
    const request = "https://pro.ip-api.com/json?key=lsCvt9AP5YqiVgL";
    return APIHandler.makeRequest(request);
  },

  getExhibitionStands: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getExhibitionStandsCategory: (id) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?id=${id}&country=true`;
    return APIHandler.makeRequest(request);
  },

  getExhibitionStandsByCategory: (category, appId) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?category=${category}&app_id=${appId}&country=true`;
    return APIHandler.makeRequest(request);
  },

  getExhibitionStandsUnsorted: (id) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?id=${id}&country=true`;
    return APIHandler.makeRequest(request);
  },

  getProfile: (profileId) => {
    const request = `https://travproconnect.com/api/v2/profile/${profileId}?format=json&chat=true`;
    return APIHandler.makeRequest(request);
  },

  getPremiumHotelsList: (lat1, lat2, lon1, lon2) => {
    const request = `https://travproconnect.com/api/v1/companies_region/?&live=true&appcode=vegas&lat1=${lat1}&lat2=${lat2}&lon1=${lon1}&lon2=${lon2}&preview=true`;
    return APIHandler.makeRequest(request);
  },

  getFreeHotelsList: (lat1, lat2, lon1, lon2, query, category, location) => {
    const request = `https://travpro.yourworldapps.nl/API/app/v2/listings.php?app=1335&lat1=${lat1}&lat2=${lat2}&lon1=${lon1}&lon2=${lon2}&query=${query}&category=${encodeURIComponent(
      category
    )}&location=${encodeURIComponent(location)}`;
    return APIHandler.makeRequest(request);
  },

  getNamedCollection: (title, appId) => {
    const request = `https://cms.travpromobile.com/api/app/named-collection?title=${title}&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getMessage: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/message/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getAnnouncement: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/notification/true/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getUnreadMessages: (appId, lastChecked) => {
    const request = `https://cms.travpromobile.com/api/app/latest_message/?app_id=${appId}&date=${lastChecked}`;
    return APIHandler.makeRequest(request);
  },

  getChapters: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/chapter-info/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getFastFacts: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/sales-companion/?app_id=${appId}&type=fastfacts&format=json`;
    return APIHandler.makeRequest(request);
  },

  getToolbox: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/sales-companion/?app_id=${appId}&type=toolbox&format=json`;
    return APIHandler.makeRequest(request);
  },

  getContacts: (appId) => {
    const request = `https://cms.travpromobile.com/api/contact-us?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getTrainingPages: (chapterId) => {
    const request = `https://cms.travpromobile.com/api/app/chapter-content/?chapter_id=${chapterId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getDLC: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/getDLC/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getVideos: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/carousel-video/?app_id=${appId}&type=both&autoPlay=true&format=json&app=new`;
    return APIHandler.makeRequest(request);
  },

  getImages: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/carousel-photo?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getCollection: (itemID) => {
    const request = `https://cms.travpromobile.com/api/app/collection?sales_companion_item_id=${itemID}`;
    return APIHandler.makeRequest(request);
  },

  getDownloadURL: (file, name, fileType) => {
    let downloadURL = "https://stack.travpromobile.com/download.php?";
    if (fileType) {
      downloadURL += `fileType=${fileType}`;
    }
    if (name) {
      downloadURL += `&name=${name}`;
    }
    downloadURL += `&url=${file}`;
    return downloadURL;
  },

  getAppInfo: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/app-info/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getSubApps: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/subApps/?format=json&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  trackEvent: (appId, email, category, name, value, label = null) => {
    const action = "click";
    const request = "https://crm.travpromobile.com/api/event";
    const data = {
      app_id: appId,
      email,
      action,
      category,
      name,
      value,
      label,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: "POST",
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then(() => false);
  },

  addReward: (
    bookingDate,
    numberOfGuests,
    firstName,
    lastName,
    accommodation,
    wholesaler,
    arrivalDate,
    departureDate,
    reservationNumber,
    numberOfRooms,
    totalCost,
    agentEmail,
    agentFirstName,
    agentLastName,
    appId
  ) => {
    const request = "https://crm.travpromobile.com/api/reward";
    const data = {
      date_booked: bookingDate,
      number_of_guests: numberOfGuests,
      client_first_name: firstName,
      client_last_name: lastName,
      accommodation_name: accommodation,
      wholesaler_name: wholesaler,
      arrival_date: arrivalDate,
      departure_date: departureDate,
      reservation_number: reservationNumber,
      number_of_rooms: numberOfRooms,
      total_cost_usd: totalCost,
      agent_email: agentEmail,
      agent_first_name: agentFirstName,
      agent_last_name: agentLastName,
      app_id: appId,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then(() => false);
  },

  startSession: (appId, email, device) => {
    const request = "https://crm.travpromobile.com/api/sessions/start";
    const data = {
      app_id: appId,
      email,
      device,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: "POST",
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings);
  },

  updateSession: (sessionId) => {
    const request = "https://crm.travpromobile.com/api/sessions/update";
    const data = {
      session_id: sessionId,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: "POST",
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then(() => false);
  },

  getIdByDomain: (domain) => {
    const request = `https://cms.travpromobile.com/api/app/getIdByDomain/?domain=https://${domain}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getLanguage: (domain) => {
    const request = `https://cms.travpromobile.com/api/app/getLangByDomain/?domain=https://${domain}&format=json`;
    return APIHandler.makeRequest(request);
  },

  loginMagicLink: async (token) => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { clientId, clientSecret } = appInfo;
    const request = "https://login.travpromobile.com/oauth/token";
    const data = {
      grant_type: "passwordless",
      client_id: clientId,
      client_secret: clientSecret,
      token,
    };
    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      method: "POST",
      timeout: 5000,
      body,
    };

    const onError = (err) =>
      // alert("Currently it's very busy, please try again at a later moment. Thank you.");
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      err;
    const res = await APIHandler.makeRequest(request, requestSettings, onError);

    if (res.response && res.response.status !== 200) {
      return onError(await res.response.clone().json());
    }
    return res;
  },

  checkEmail(email) {
    const request = `https://login.travpromobile.com/api/user-exists?email=${email}`;
    return APIHandler.makeRequest(request, { method: "POST" });
  },

  magicLink: async (email, language) => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { clientId, appURL } = appInfo;

    const request = "https://login.travpromobile.com/api/login/passwordless";

    const formData = new FormData();
    formData.append("email", email);
    formData.append("client_id", clientId);
    formData.append("url", appURL);
    formData.append("language", language);

    const requestSettings = {
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      timeout: 5000,
      body: formData,
    };

    const onError = (err) =>
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      err;
    const res = await APIHandler.makeRequest(
      request,
      requestSettings,
      requestSettings,
      onError
    );
    return res;
  },

  checkPasswordUser: (email, password) => {
    const request = "https://crm.travpromobile.com/api/authenticateMalibu";
    const data = {
      email,
      password,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: "POST",
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then((res) => res);
  },
};
